import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../../store/store";

const baseUrl = process.env.REACT_APP_base_URL;

const addGroupUsers = createApi({
  reducerPath: "addGroupUsers",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      // const token = useSelector((state)=> state.user.token)
      const token = store.getState().user.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
  },
  }),
  endpoints: (builder) => ({
    addUser: builder.mutation({
      query: ({ chatId, user_id }) => ({
        url: `chat/add`,
        method: "PUT",
        body: {
          chatId: chatId,
          userId: [user_id],
        },
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { useAddUserMutation } = addGroupUsers;
export default addGroupUsers;
